import { createFileRoute } from "@tanstack/react-router";
import AdminFloorplanImport from "@/pages/admin/AdminFloorplanImport";

export const Route = createFileRoute("/_adminLayout/admin/floorplan-import")({
  component: AdminFloorplanImport,
});
